<template>
  <el-select
    v-model="value"
    :popper-append-to-body="false"
    :loading="isLoading"
    :placeholder="placeholder"
    :disabled="disabled"
    @input.native="handlerInput"
    @change="handlerChange"
    :clearable="clearable"
    filterable
    :multiple-limit="multipleLimit"
    :multiple="multiple"
    :size="size"
    popper-class="mode-column is-mobile"
    @focus="handlerFocus"
    @paste.native="handlePaste"
    ref="select">
    <template v-slot:prefix>
      <slot name="prefix" />
    </template>
    <slot name="select-info" />
    <li class="mode-column__header">
      <div
        v-for="(column, i) in columns"
        :key="i"
        class="mode-column__header-item"
      >{{column.title}}</div>
    </li>
    <el-option
      v-for="item in showedData"
      :key="item[fields.id]"
      :label="getLabel(item)"
      :value="item[fields.id]"
      :disabled="!!item.disabled"
    >
      <template>
        <div class="mode-column__list">
          <div
            class="mode-column__list-item"
            v-for="(column, i) in columns"
            :key="i"
            :title="item[column.value]"
          >{{parseColumnValue(item, column)}}</div>
        </div>
      </template>
    </el-option>
  </el-select>
</template>

<script>
import { select, selectColumns } from './mixins'
export default {
  name: 'MobileColumns',
  mixins: [select, selectColumns]
}
</script>
